export const VALUE_RANGES = [
  { label: "All Values",  min: 0,     max: Infinity },
  { label: "Under $10K",  min: 0,     max: 9999 },
  { label: "$10K – $25K", min: 10000, max: 25000 },
  { label: "Above $25K",  min: 25001, max: Infinity },
];

export const CONTRACT_STATUSES  = ["Active","Draft" , "Completed", "Cancelled","All", ];
export const TIMESHEET_STATUSES = ["All", "Approved", "Pending"];
export const TASK_STATUSES      = ["All", "To Do", "In Progress", "Done","Hold"];
export const PAYMENT_STATUSES   = ["All", "Paid", "Pending"];
export const INVOICE_STATUSES   = ["All", "Paid", "Unpaid", "Overdue"];

export function formatValue(n) {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString();
}
